import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

import { cn } from 'support/helpers/cn/cn';
import { NavigationLink, NavigationLinkGroup } from 'components/Page/types';

type SecondaryNavigationItemProps = {
  href: string;
  label: ReactNode;
  onClick?: () => void;
};

export const SecondaryNavigation = ({ linkGroups }: { linkGroups: Array<NavigationLinkGroup> }) => {
  return (
    <div className="flex flex-col pt-4 pl-4 sm:pl-6 md:pl-8" style={{ height: 'var(--content-height)' }}>
      <div className="flex w-64 flex-1 shrink-0 flex-col">
        <div className="flex flex-1 flex-col justify-between overflow-y-auto">
          <div className="flex flex-1 flex-col gap-6">
            {linkGroups.map((linkGroup: NavigationLinkGroup, linkGroupIndex) => (
              <div key={linkGroupIndex}>
                {!!linkGroup.title && (
                  <div className="mb-3 text-xs leading-4 font-medium text-gray-400 uppercase">{linkGroup.title}</div>
                )}
                <div className="flex flex-col space-y-1">
                  {linkGroup.links
                    .filter((link) => !link.hidden)
                    .map((link: NavigationLink) => (
                      <SecondaryNavigationItem href={link.href!} label={link.label} key={link.href} />
                    ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const getLinkClasses = ({ isActive }: { isActive: boolean }) =>
  cn(
    isActive ? 'bg-gray-200 text-gray-900' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900',
    'group relative rounded-md rounded-md px-3 py-2 text-sm font-medium',
  );

const SecondaryNavigationItem = ({ href, label, onClick }: SecondaryNavigationItemProps) => {
  return (
    <NavLink to={href} className={getLinkClasses} onClick={onClick}>
      <div className="flex w-full flex-row items-center justify-between">
        <div className="flex w-full flex-row items-center">
          <span className="flex h-6 w-full items-center justify-between text-sm leading-none">{label}</span>
        </div>
      </div>
    </NavLink>
  );
};
